import React from 'react';
import { DropEvent, useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';
import { Box } from '~common/components/box.component';
import { Column } from '~common/components/column.component';
import { Span } from '~common/components/span.component';
import { UploadIcon } from '~web/view/components/ui/icon/upload.icon';

interface Props {
  accept?: string | string[];
  onDropAccepted?: (files: File[], event?: DropEvent) => void;
  maxFiles?: number;
}

export const FileDropzone: React.FunctionComponent<Props> = ({
  accept,
  onDropAccepted,
  maxFiles,
  ...rest
}) => {
  const { t } = useTranslation();
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDropAccepted,
    accept,
    maxFiles,
  });

  return (
    <Container isDragActive={isDragActive} {...rest}>
      <Inner {...getRootProps()}>
        <input {...getInputProps()} />
        <DropZone>
          <UploadText>{t('form.importFromFile')}</UploadText>
          <UploadIcon width={32} height={32} />
        </DropZone>
      </Inner>
    </Container>
  );
};

const Container = styled(({ isDragActive, ...rest }) => <Box {...rest} />)<{
  isDragActive: boolean;
}>`
  ${(props): FlattenSimpleInterpolation | null =>
    props.isDragActive &&
    css`
      opacity: 0.5;
    `};
`;

const Inner = styled.div`
  flex: 1 1 auto;
  outline: none;
  cursor: pointer;
`;

const DropZone = styled(Column)`
  width: 100%;
  padding: 16px;
  border: 2px solid ${(props): string => props.theme.colors.gray.v3};
  border-radius: 16px;
  align-items: center;
  justify-content: space-around;
`;

const UploadText = styled(Span)`
  line-height: 20px;
  letter-spacing: 0.8px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 16px;
`;



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/file/file-dropzone.component.tsx